import {
    CLINIC_ID,
    GET_CLINIC_STATUS,
    GET_CLINIC_LIST_SELECTED_STATE,
    GET_CLINIC_STATES,
    SHOW_CLINICS_WITHOUT_STRIPE_GLOBAL_STATE,
    SHOW_CLINICS_WITH_SMS_NOTIFICATIONS,
    SHOW_RCM_CLINICS_GLOBAL_STATE,
    GET_CUSTOMER_STATUSES,
    GET_SELECTED_CUSTOMER_STATUS,
} from "../actions";

export const clinicIDReducer = (state = false, action) => {
    switch (action.type) {
        case CLINIC_ID:
            return action.payload;
        default:
            return state;
    }
};

export const clinicStatusReducer = (state = false, action) => {
    switch (action.type) {
        case GET_CLINIC_STATUS:
            return action.payload;
        default:
            return state;
    }
};

export const clinicsSelectedStateReducer = (state = false, action) => {
    switch (action.type) {
        case GET_CLINIC_LIST_SELECTED_STATE:
            return action.payload;
        default:
            return state;
    }
};

export const clinicStatesReducer = (state = [], action) => {
    switch (action.type) {
        case GET_CLINIC_STATES:
            return action.payload;
        default:
            return state;
    }
};

export const clinicToggleForStripeReducer = (state = false, action) => {
    switch (action.type) {
        case SHOW_CLINICS_WITHOUT_STRIPE_GLOBAL_STATE:
            return action.payload;
        default:
            return state;
    }
};

export const clinicToggleForSmsNotificationsReducer = (state = false, action) => {
    switch (action.type) {
        case SHOW_CLINICS_WITH_SMS_NOTIFICATIONS:
            return action.payload;
        default:
            return state;
    }
};

export const clinicToggleForRCMReducer = (state = false, action) => {
    switch (action.type) {
        case SHOW_RCM_CLINICS_GLOBAL_STATE:
            return action.payload;
        default:
            return state;
    }
};

export const customerStatusesReducer = (state = [], action) => {
    switch (action.type) {
        case GET_CUSTOMER_STATUSES:
            return action.payload;
        default:
            return state;
    }
};


export const selectedCustomerStatusReducer = (
    state = null,
    action
) => {
    switch (action.type) {
        case GET_SELECTED_CUSTOMER_STATUS:
            return action.payload;

        default:
            return state;
    }
};




